// client/src/PbSkillsSolarPopup.tsx
import * as React from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PbSkillsSolar } from "./pbSkillsSolar/PBSkillsSolar";   // /pbSkillsSolar/PbSkillsSolar";

export function PbSkillsSolarPopup(props: {
  open: boolean;
  onClose: () => void;
}) {
  const { open, onClose } = props;

  const [pos, setPos] = React.useState<{ x: number; y: number }>({
    x: 22,
    y: 96,
  });

  const dragRef = React.useRef<{
    startX: number;
    startY: number;
    startPosX: number;
    startPosY: number;
    dragging: boolean;
  } | null>(null);

  const onMouseDownHeader = (e: React.MouseEvent) => {
    if (e.button !== 0) return;
    dragRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      startPosX: pos.x,
      startPosY: pos.y,
      dragging: true,
    };
    e.preventDefault();
  };

  React.useEffect(() => {
    const onMove = (e: MouseEvent) => {
      const d = dragRef.current;
      if (!d?.dragging) return;

      const dx = e.clientX - d.startX;
      const dy = e.clientY - d.startY;

      const nextX = Math.max(0, Math.min(window.innerWidth - 260, d.startPosX + dx));
      const nextY = Math.max(0, Math.min(window.innerHeight - 160, d.startPosY + dy));
      setPos({ x: nextX, y: nextY });
    };

    const onUp = () => {
      if (dragRef.current) dragRef.current.dragging = false;
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
  }, [pos.x, pos.y]);

  if (!open) return null;

  return (
    <Paper
      elevation={10}
      data-happy-path="pickleball-universe-popup"
      sx={{
        position: "fixed",
        left: pos.x,
        top: pos.y,
        width: 1600,
        maxWidth: "calc(100vw - 36px)",
        height: "92vh",
        maxHeight: "calc(100vh - 120px)",
        borderRadius: 2,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        zIndex: 2000,
        border: "1px solid rgba(0,0,0,0.14)",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 1.5,
          py: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid rgba(0,0,0,0.12)",
          cursor: "grab",
          "&:active": { cursor: "grabbing" },
        }}
        onMouseDown={onMouseDownHeader}
      >
        <Typography sx={{ fontWeight: 900 }}>
          Pickleball Universe
        </Typography>

        <Button
          size="small"
          variant="text"
          data-happy-path="pickleball-universe-close"
          onClick={onClose}
          startIcon={<CloseIcon />}
          sx={{ textTransform: "none", fontWeight: 900 }}
        >
          Close
        </Button>
      </Box>

      {/* Body */}
      <Box sx={{ flex: 1, minHeight: 0 }}>
        {/* Important: give the solar app a real height */}
        <Box data-happy-path="pickleball-universe-stage" sx={{ width: "100%", height: "100%" }}>
          <PbSkillsSolar />
        </Box>
      </Box>
    </Paper>
  );
}
